<template>
    <div>
        <b-card>
            <b-card-header>
                <b-btn :to="{ path: '/home' }"><span class='esri-icon-left-arrow'></span> Home</b-btn>
            </b-card-header>
            <b-card-body>
                <b-row>
                <b-input-group>
                    <b-form-input 
                        v-model='searchText' 
                        placeholder="User Name or Full Name. End with `*` for wild-card searching... "
                        v-on:change="startFilter">
                    </b-form-input>
                    <b-btn v-on:click='startFilter'>Filter</b-btn>
                </b-input-group>      
                </b-row>
                <b-row>
                    <b-col>
                <details-table 
                    v-if='showDetailsTable && portalUsersQueryProvider'
                    :perPage="6"
                    :tableProvider='portalUsersQueryProvider'
                    :tableFields='portalUserTableFields'
                    :disableEndFilter='true'
                    tableId='user-roles-management-list-panel-details-table'
                    v-on:edit="onDetailEdit"
                    v-on:endFilter="endFilter">
                </details-table>
                </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <b-modal 
            id="user-roles-management-detail-modal" 
            ref="userRolesManagementDetailModal" 
            size="lg" 
            :title="'User being edited: ' + this.$store.state.userSystemLevels['user_name']"
            ok-title="Save"
            v-on:ok="onOkClicked">
            <user-roles-management-detail-panel ref="userRolesManagementDetailPanel"/>
        </b-modal>
    </div>
</template>

<script>
import DetailsTable from "@/components/ui-components/DetailsTable";
import UserRolesManagementDetailPanel from "@/components/account/ui-components/UserRolesManagementDetailPanel";
import {generatePortalUserQueryProvider} from "@/service/restAPIHelper";

export default {
    components:{
        UserRolesManagementDetailPanel,
        DetailsTable
    },
    data:function(){
        return {
            searchText:'',
            generatePortalUserQueryProvider:generatePortalUserQueryProvider,
            portalUsersQueryProvider:null,
            showDetailsTable:true,

            portalUserTableFields:[
                { "key": 'user_name', "label": 'User Name' },
                { "key": 'user_full_name', "label": 'Full Name' },
                // { "key": 'user_system_levels_for_display', "label": 'System' },
                { "key": 'edit', "label": '' }
            ]
        }
    },
    methods:{
        onOkClicked: function (e) {
            this.$refs.userRolesManagementDetailPanel.onSave();
        },
        onDetailEdit:function(item){
            // console.log('start editing',item)
            this.$refs.userRolesManagementDetailModal.show();
            var flatten_user_system_levels = {};
            var flatten_user_systems = item.user_system_levels.map((eachLevel)=>{ 
                return eachLevel.name
            });
            
            var temp = {}
            item.user_system_levels.map((eachLevel)=>{       
                temp[eachLevel.name] = eachLevel.level 
            });
            
            
            flatten_user_system_levels.user_name = item.user_name
            flatten_user_system_levels.user_systems = flatten_user_systems
            flatten_user_system_levels.user_system_levels = temp

            this.$store.dispatch(
                "userSystemLevels/setupState",
                flatten_user_system_levels
            );             
        },
        refreshPortalUserQueryProvider:function(searchText){

            var options = {
            
            }
            if(searchText){
                options.q = searchText;
            }

            this.portalUsersQueryProvider = generatePortalUserQueryProvider(options)
        },
        startFilter:function(){
            this.refreshPortalUserQueryProvider(this.searchText);
        },
        endFilter:function(){
            this.searchText = "";
            this.refreshPortalUserQueryProvider();

        }
    },
    mounted:function(){
        this.portalUsersQueryProvider = generatePortalUserQueryProvider();
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/account/ui-components/UserRolesManagementListPanel.vue